import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icon/search (2).png'
import _imports_1 from '@/assets/icon/user-19.png'
import _imports_2 from '@/assets/icon/tel.png'


const _hoisted_1 = { class: "header clearfix" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "rep_search" }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = {
  class: "logos",
  style: {"display":"flex","align-items":"center"}
}

import { onMounted, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { trim } from 'core-js/internals/string-trim'
import { Search } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {

const input = ref('')
const show = ref(false)
const isReads = ref(0)
const router = useRouter()
const route = useRoute()
const token = ref('')
// 搜索框搜索函数
const toSearch = () => {
  input.value = trim(input.value)
  show.value = false
  if (input.value.length === 0 || input.value.split(" ").join("").length === 0) {
    return false
  } else {
      router.push('/search/' + encodeURIComponent(input.value))
  }
  // 利用变量判断是否重复搜索开始
  if (input.value === input.value) {
    isReads.value++
  }
  if (isReads.value === 2 && input.value !== '') {
    router.push('/search/' + encodeURIComponent(input.value) + ' ')
    isReads.value = 0
  }
  // 利用变量判断是否重复搜索结束
}

onMounted(() => {
  if (route.params.fruitKey) {
    input.value = trim(decodeURIComponent(route.params.fruitKey as string))
  }
})

// 组件创建时的逻辑
// if (route.params.id) {
//   input.value = trim(decodeURIComponent(route.params.id as string))
// }

// 监听路由变化
watch(() => route.path, (newVal) => {
  const result = newVal.split('/')
  let finilly = result[2] && result[2].includes('.html') ? result[2].split('.html')[0] : result[2]
  if (result[1] !== 'search') {
    input.value = ''
  } else {
    input.value = decodeURIComponent(finilly)
  }  
  token.value = localStorage.getItem('MklUserToken') ? localStorage.getItem('MklUserToken') : ''
})

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_image, {
            src: require('@/assets/logo.png'),
            fit: "scale-down"
          }, null, 8, ["src"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(['clearfix','search_bg',{'search_focus': show.value === true}])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              class: "input_text",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
              ref: "input_text",
              type: "text",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (show.value = true)),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (show.value = false)),
              onKeyup: _withKeys(toSearch, ["enter"]),
              placeholder: "请输入产品编码，CAS编码，关键字或结构式查询"
            }, null, 544), [
              [_vModelText, input.value]
            ])
          ]),
          _createElementVNode("div", { style: {"display":"flex","align-items":"center"} }, [
            _createElementVNode("div", {
              class: "btn_search",
              onClick: toSearch,
              style: {"display":"flex","align-items":"center","justify-content":"center"}
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                style: {"width":"35px","margin-right":"5px"}
              }, null, -1)
            ]))
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        src: _imports_1,
        style: {"width":"35px","cursor":"pointer"},
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/profileInfo'))),
        alt: ""
      }),
      _cache[5] || (_cache[5] = _createElementVNode("img", {
        src: _imports_2,
        style: {"width":"160px","margin-bottom":"3px"},
        alt: ""
      }, null, -1))
    ])
  ]))
}
}

})